import React, { useState, useEffect } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const useStyles = makeStyles((theme) => ({
  scrollToTopBtn: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    padding: theme.spacing(2,2),
    backgroundColor: '#3fc',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#34b',
    },
    zIndex: 1000,
  },
}));

const ScrollToTopButton = () => {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    visible && (
      <Button
        variant="contained"
        className={classes.scrollToTopBtn}
        onClick={scrollToTop}
      >
        <ArrowUpwardIcon />
      </Button>
    )
  );
};

export default ScrollToTopButton;
